import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetCollectionsReportAction } from '@/application/actions';
import type { CollectionsReportDTO } from '@/domain/repositories/IReportRepository';

export const useCollectionsReport = () => {
  const [report, setReport] = useState<CollectionsReportDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetCollectionsReportAction>(TYPES.GetCollectionsReportAction);
      setReport(await action.execute());
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load collections report'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { report, isLoading, error, refetch: load };
};
